// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery-banner {
  text-align: center;
}

@media only screen and (max-width: 767px) {
  .gallery .honeycomb {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    justify-content: center;
    align-items: center;
    max-width: 767px;
    margin: 0 auto 200px auto;
    padding: 0;
    transform: translateY(13.75px);
  }
  .gallery .honeycomb-cell {
    flex: 0 1 100px;
    max-width: 100px;
    height: 55px;
    margin: 26.1904761905px 7.5px 15px;
    position: relative;
    padding: 0.5em;
    text-align: center;
    z-index: 1;
  }
  .gallery .honeycomb-cell__title {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    hyphens: auto;
    word-break: break-word;
    text-transform: uppercase;
    color: #fff;
    font-weight: 700;
    font-size: 1.75em;
    transition: opacity 350ms;
  }
  .gallery .honeycomb-cell__title > small {
    font-weight: 300;
    margin-top: 0.25em;
  }
  .gallery .honeycomb-cell__image {
    object-fit: cover;
    object-position: center;
  }
  .gallery .honeycomb-cell::before, .gallery .honeycomb-cell::after {
    content: "";
  }
  .gallery .honeycomb-cell::before, .gallery .honeycomb-cell::after, .gallery .honeycomb-cell__image {
    top: -50%;
    left: 0;
    width: 100%;
    height: 200%;
    display: block;
    position: absolute;
    clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
    z-index: -1;
  }
  .gallery .honeycomb-cell::before {
    background: #fff;
    transform: scale(1.055);
  }
  .gallery .honeycomb-cell::after {
    background: #13a89e;
    opacity: 0.4;
    transition: opacity 350ms;
  }
  .gallery .honeycomb-cell:hover .honeycomb-cell__title {
    opacity: 0;
  }
  .gallery .honeycomb-cell:hover::before, .gallery .honeycomb-cell:hover::after, .gallery .honeycomb-cell:hover .honeycomb-cell__image {
    clip-path: unset !important;
  }
  .gallery .honeycomb-cell:hover::before {
    background: #13a89e;
  }
  .gallery .honeycomb-cell:hover::after {
    opacity: 0;
  }
  .gallery .honeycomb__placeholder {
    display: none;
    opacity: 0;
    width: 100px;
    margin: 0 7.5px;
  }
}
@media only screen and (max-width: 767px) and (max-width: 230px) {
  .gallery .honeycomb-cell {
    margin: 35px 15px;
  }
}
@media only screen and (max-width: 767px) and (min-width: 230px) and (max-width: 345px) {
  .gallery .honeycomb-cell:nth-child(3n) {
    margin-right: calc(50% - 50px);
    margin-left: calc(50% - 50px);
  }
  .gallery .honeycomb__placeholder:nth-child(3n+5) {
    display: block;
  }
}
@media only screen and (max-width: 767px) and (min-width: 345px) and (max-width: 460px) {
  .gallery .honeycomb-cell:nth-child(5n+4) {
    margin-left: calc(50% - 115px);
  }
  .gallery .honeycomb-cell:nth-child(5n+5) {
    margin-right: calc(50% - 115px);
  }
  .gallery .honeycomb__placeholder:nth-child(5n), .gallery .honeycomb__placeholder:nth-child(5n+3) {
    display: block;
  }
}
@media only screen and (max-width: 767px) and (min-width: 460px) {
  .gallery .honeycomb-cell:nth-child(7n+5) {
    margin-left: calc(50% - 165px);
  }
  .gallery .honeycomb-cell:nth-child(7n+7), .gallery .honeycomb-cell:nth-child(7n+5):nth-last-child(2) {
    margin-right: calc(50% - 165px);
  }
  .gallery .honeycomb__placeholder:nth-child(7n+7), .gallery .honeycomb__placeholder:nth-child(7n+9), .gallery .honeycomb__placeholder:nth-child(7n+11) {
    display: block;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .gallery .honeycomb {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    justify-content: center;
    align-items: center;
    max-width: 1023px;
    margin: 0 auto 200px auto;
    padding: 0;
    transform: translateY(27.5px);
  }
  .gallery .honeycomb-cell {
    flex: 0 1 200px;
    max-width: 200px;
    height: 110px;
    margin: 52.380952381px 7.5px 15px;
    position: relative;
    padding: 0.5em;
    text-align: center;
    z-index: 1;
  }
  .gallery .honeycomb-cell__title {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    hyphens: auto;
    word-break: break-word;
    text-transform: uppercase;
    color: #fff;
    font-weight: 700;
    font-size: 1.75em;
    transition: opacity 350ms;
  }
  .gallery .honeycomb-cell__title > small {
    font-weight: 300;
    margin-top: 0.25em;
  }
  .gallery .honeycomb-cell__image {
    object-fit: cover;
    object-position: center;
  }
  .gallery .honeycomb-cell::before, .gallery .honeycomb-cell::after {
    content: "";
  }
  .gallery .honeycomb-cell::before, .gallery .honeycomb-cell::after, .gallery .honeycomb-cell__image {
    top: -50%;
    left: 0;
    width: 100%;
    height: 200%;
    display: block;
    position: absolute;
    clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
    z-index: -1;
  }
  .gallery .honeycomb-cell::before {
    background: #fff;
    transform: scale(1.055);
  }
  .gallery .honeycomb-cell::after {
    background: #13a89e;
    opacity: 0.4;
    transition: opacity 350ms;
  }
  .gallery .honeycomb-cell:hover .honeycomb-cell__title {
    opacity: 0;
  }
  .gallery .honeycomb-cell:hover::before, .gallery .honeycomb-cell:hover::after, .gallery .honeycomb-cell:hover .honeycomb-cell__image {
    clip-path: unset !important;
  }
  .gallery .honeycomb-cell:hover::before {
    background: #13a89e;
  }
  .gallery .honeycomb-cell:hover::after {
    opacity: 0;
  }
  .gallery .honeycomb__placeholder {
    display: none;
    opacity: 0;
    width: 200px;
    margin: 0 7.5px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1023px) and (max-width: 430px) {
  .gallery .honeycomb-cell {
    margin: 62.5px 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1023px) and (min-width: 430px) and (max-width: 645px) {
  .gallery .honeycomb-cell:nth-child(3n) {
    margin-right: calc(50% - 100px);
    margin-left: calc(50% - 100px);
  }
  .gallery .honeycomb__placeholder:nth-child(3n+5) {
    display: block;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1023px) and (min-width: 645px) and (max-width: 860px) {
  .gallery .honeycomb-cell:nth-child(5n+4) {
    margin-left: calc(50% - 215px);
  }
  .gallery .honeycomb-cell:nth-child(5n+5) {
    margin-right: calc(50% - 215px);
  }
  .gallery .honeycomb__placeholder:nth-child(5n), .gallery .honeycomb__placeholder:nth-child(5n+3) {
    display: block;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1023px) and (min-width: 860px) {
  .gallery .honeycomb-cell:nth-child(7n+5) {
    margin-left: calc(50% - 315px);
  }
  .gallery .honeycomb-cell:nth-child(7n+7), .gallery .honeycomb-cell:nth-child(7n+5):nth-last-child(2) {
    margin-right: calc(50% - 315px);
  }
  .gallery .honeycomb__placeholder:nth-child(7n+7), .gallery .honeycomb__placeholder:nth-child(7n+9), .gallery .honeycomb__placeholder:nth-child(7n+11) {
    display: block;
  }
}
@media only screen and (min-width: 1024px) {
  .gallery .honeycomb {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    justify-content: center;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto 200px auto;
    padding: 0;
    transform: translateY(34.375px);
  }
  .gallery .honeycomb-cell {
    flex: 0 1 250px;
    max-width: 250px;
    height: 137.5px;
    margin: 65.4761904762px 7.5px 15px;
    position: relative;
    padding: 0.5em;
    text-align: center;
    z-index: 1;
  }
  .gallery .honeycomb-cell__title {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    hyphens: auto;
    word-break: break-word;
    text-transform: uppercase;
    color: #fff;
    font-weight: 700;
    font-size: 1.75em;
    transition: opacity 350ms;
  }
  .gallery .honeycomb-cell__title > small {
    font-weight: 300;
    margin-top: 0.25em;
  }
  .gallery .honeycomb-cell__image {
    object-fit: cover;
    object-position: center;
  }
  .gallery .honeycomb-cell::before, .gallery .honeycomb-cell::after {
    content: "";
  }
  .gallery .honeycomb-cell::before, .gallery .honeycomb-cell::after, .gallery .honeycomb-cell__image {
    top: -50%;
    left: 0;
    width: 100%;
    height: 200%;
    display: block;
    position: absolute;
    clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
    z-index: -1;
  }
  .gallery .honeycomb-cell::before {
    background: #fff;
    transform: scale(1.055);
  }
  .gallery .honeycomb-cell::after {
    background: #13a89e;
    opacity: 0.4;
    transition: opacity 350ms;
  }
  .gallery .honeycomb-cell:hover .honeycomb-cell__title {
    opacity: 0;
  }
  .gallery .honeycomb-cell:hover::before, .gallery .honeycomb-cell:hover::after, .gallery .honeycomb-cell:hover .honeycomb-cell__image {
    clip-path: unset !important;
  }
  .gallery .honeycomb-cell:hover::before {
    background: #13a89e;
  }
  .gallery .honeycomb-cell:hover::after {
    opacity: 0;
  }
  .gallery .honeycomb__placeholder {
    display: none;
    opacity: 0;
    width: 250px;
    margin: 0 7.5px;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 530px) {
  .gallery .honeycomb-cell {
    margin: 76.25px 15px;
  }
}
@media only screen and (min-width: 1024px) and (min-width: 530px) and (max-width: 795px) {
  .gallery .honeycomb-cell:nth-child(3n) {
    margin-right: calc(50% - 125px);
    margin-left: calc(50% - 125px);
  }
  .gallery .honeycomb__placeholder:nth-child(3n+5) {
    display: block;
  }
}
@media only screen and (min-width: 1024px) and (min-width: 795px) and (max-width: 1060px) {
  .gallery .honeycomb-cell:nth-child(5n+4) {
    margin-left: calc(50% - 265px);
  }
  .gallery .honeycomb-cell:nth-child(5n+5) {
    margin-right: calc(50% - 265px);
  }
  .gallery .honeycomb__placeholder:nth-child(5n), .gallery .honeycomb__placeholder:nth-child(5n+3) {
    display: block;
  }
}
@media only screen and (min-width: 1024px) and (min-width: 1060px) {
  .gallery .honeycomb-cell:nth-child(7n+5) {
    margin-left: calc(50% - 390px);
  }
  .gallery .honeycomb-cell:nth-child(7n+7), .gallery .honeycomb-cell:nth-child(7n+5):nth-last-child(2) {
    margin-right: calc(50% - 390px);
  }
  .gallery .honeycomb__placeholder:nth-child(7n+7), .gallery .honeycomb__placeholder:nth-child(7n+9), .gallery .honeycomb__placeholder:nth-child(7n+11) {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/gallery/gallery.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AA+JE;EApJE;IACE,aAAA;IACA,eAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;IACA,gBAkJoB;IAjJpB,yBAAA;IACA,UAAA;IACA,8BAAA;EAPJ;EASI;IACE,eAAA;IACA,gBAwIY;IAvIZ,YAwIa;IAvIb,kCAAA;IACA,kBAAA;IACA,cAAA;IAEA,kBAAA;IACA,UAAA;EARN;EAWM;IACE,YAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,aAAA;IACA,sBAAA;IACA,yBAAA;IACA,WAAA;IACA,gBAAA;IACA,iBAAA;IACA,yBAAA;EATR;EAWQ;IACE,gBAAA;IACA,kBAAA;EATV;EAaM;IACE,iBAAA;IACA,uBAAA;EAXR;EAcM;IACE,WAAA;EAZR;EAeM;IACE,SAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,cAAA;IACA,kBAAA;IACA,wEAAA;IACA,WAAA;EAbR;EAgBM;IACE,gBArEe;IAsEf,uBAAA;EAdR;EAiBM;IACE,mBAxEc;IAyEd,YAAA;IACA,yBAAA;EAfR;EAoBQ;IACE,UAAA;EAlBV;EAqBQ;IACE,2BAAA;EAnBV;EAsBQ;IACE,mBAzFoB;EAqE9B;EAuBQ;IACE,UAAA;EArBV;EA0BI;IACE,aAAA;IACA,UAAA;IACA,YAqDY;IApDZ,eAAA;EAxBN;AACF;AA2BI;EACE;IACE,iBAAA;EAzBN;AACF;AA4BI;EACE;IACE,8BAAA;IACA,6BAAA;EA1BN;EA6BI;IACE,cAAA;EA3BN;AACF;AA8BI;EACE;IACE,8BAAA;EA5BN;EA+BI;IACE,+BAAA;EA7BN;EAgCI;IACE,cAAA;EA9BN;AACF;AAiCI;EACE;IACE,8BAAA;EA/BN;EAkCI;IACE,+BAAA;EAhCN;EAmCI;IACE,cAAA;EAjCN;AACF;AA+CE;EA7JE;IACE,aAAA;IACA,eAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;IACA,iBA2JoB;IA1JpB,yBAAA;IACA,UAAA;IACA,6BAAA;EAiHJ;EA/GI;IACE,eAAA;IACA,gBAiJY;IAhJZ,aAiJa;IAhJb,iCAAA;IACA,kBAAA;IACA,cAAA;IAEA,kBAAA;IACA,UAAA;EAgHN;EA7GM;IACE,YAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,aAAA;IACA,sBAAA;IACA,yBAAA;IACA,WAAA;IACA,gBAAA;IACA,iBAAA;IACA,yBAAA;EA+GR;EA7GQ;IACE,gBAAA;IACA,kBAAA;EA+GV;EA3GM;IACE,iBAAA;IACA,uBAAA;EA6GR;EA1GM;IACE,WAAA;EA4GR;EAzGM;IACE,SAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,cAAA;IACA,kBAAA;IACA,wEAAA;IACA,WAAA;EA2GR;EAxGM;IACE,gBArEe;IAsEf,uBAAA;EA0GR;EAvGM;IACE,mBAxEc;IAyEd,YAAA;IACA,yBAAA;EAyGR;EApGQ;IACE,UAAA;EAsGV;EAnGQ;IACE,2BAAA;EAqGV;EAlGQ;IACE,mBAzFoB;EA6L9B;EAjGQ;IACE,UAAA;EAmGV;EA9FI;IACE,aAAA;IACA,UAAA;IACA,YA8DY;IA7DZ,eAAA;EAgGN;AACF;AA7FI;EACE;IACE,mBAAA;EA+FN;AACF;AA5FI;EACE;IACE,+BAAA;IACA,8BAAA;EA8FN;EA3FI;IACE,cAAA;EA6FN;AACF;AA1FI;EACE;IACE,8BAAA;EA4FN;EAzFI;IACE,+BAAA;EA2FN;EAxFI;IACE,cAAA;EA0FN;AACF;AAvFI;EACE;IACE,8BAAA;EAyFN;EAtFI;IACE,+BAAA;EAwFN;EArFI;IACE,cAAA;EAuFN;AACF;AAhEE;EAtKE;IACE,aAAA;IACA,eAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;IACA,iBAoKoB;IAnKpB,yBAAA;IACA,UAAA;IACA,+BAAA;EAyOJ;EAvOI;IACE,eAAA;IACA,gBA0JY;IAzJZ,eA0Ja;IAzJb,kCAAA;IACA,kBAAA;IACA,cAAA;IAEA,kBAAA;IACA,UAAA;EAwON;EArOM;IACE,YAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,aAAA;IACA,sBAAA;IACA,yBAAA;IACA,WAAA;IACA,gBAAA;IACA,iBAAA;IACA,yBAAA;EAuOR;EArOQ;IACE,gBAAA;IACA,kBAAA;EAuOV;EAnOM;IACE,iBAAA;IACA,uBAAA;EAqOR;EAlOM;IACE,WAAA;EAoOR;EAjOM;IACE,SAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,cAAA;IACA,kBAAA;IACA,wEAAA;IACA,WAAA;EAmOR;EAhOM;IACE,gBArEe;IAsEf,uBAAA;EAkOR;EA/NM;IACE,mBAxEc;IAyEd,YAAA;IACA,yBAAA;EAiOR;EA5NQ;IACE,UAAA;EA8NV;EA3NQ;IACE,2BAAA;EA6NV;EA1NQ;IACE,mBAzFoB;EAqT9B;EAzNQ;IACE,UAAA;EA2NV;EAtNI;IACE,aAAA;IACA,UAAA;IACA,YAuEY;IAtEZ,eAAA;EAwNN;AACF;AArNI;EACE;IACE,oBAAA;EAuNN;AACF;AApNI;EACE;IACE,+BAAA;IACA,8BAAA;EAsNN;EAnNI;IACE,cAAA;EAqNN;AACF;AAlNI;EACE;IACE,8BAAA;EAoNN;EAjNI;IACE,+BAAA;EAmNN;EAhNI;IACE,cAAA;EAkNN;AACF;AA/MI;EACE;IACE,8BAAA;EAiNN;EA9MI;IACE,+BAAA;EAgNN;EA7MI;IACE,cAAA;EA+MN;AACF","sourcesContent":[".gallery-banner {\r\n  text-align: center;\r\n}\r\n\r\n.gallery {\r\n  $hexagon-margin: 15px;\r\n  $hexagon-title-color: #fff;\r\n  $hexagon-border-color: #fff;\r\n  $hexagon-border-color--hover: #13a89e;\r\n  $hexagon-image-color: #13a89e;\r\n\r\n  \r\n  @mixin honeycomb-styling($hexagon-width, $hexagon-height, $viewport-thereshold, $honeycomb-max-width) {\r\n    .honeycomb {\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      list-style: none;\r\n      justify-content: center;\r\n      align-items: center;\r\n      max-width: $honeycomb-max-width;\r\n      margin: 0 auto 200px auto;\r\n      padding: 0;\r\n      transform: translateY(calc($hexagon-height/4));\r\n\r\n      &-cell {\r\n        flex: 0 1 $hexagon-width;\r\n        max-width: $hexagon-width;\r\n        height: $hexagon-height;\r\n        margin: calc($hexagon-height/2.1) calc($hexagon-margin/2) $hexagon-margin;\r\n        position: relative;\r\n        padding: 0.5em;\r\n\r\n        text-align: center;\r\n        z-index: 1;\r\n\r\n\r\n        &__title {\r\n          height: 100%;\r\n          display: flex;\r\n          flex-direction: column;\r\n          justify-content: center;\r\n          hyphens: auto;\r\n          word-break: break-word;\r\n          text-transform: uppercase;\r\n          color: #fff;\r\n          font-weight: 700;\r\n          font-size: 1.75em;\r\n          transition: opacity 350ms;\r\n          \r\n          > small {\r\n            font-weight: 300;\r\n            margin-top: 0.25em;\r\n          }\r\n        }\r\n\r\n        &__image {\r\n          object-fit: cover;\r\n          object-position: center;\r\n        }\r\n        \r\n        &::before, &::after {\r\n          content: '';\r\n        }\r\n\r\n        &::before, &::after, &__image {\r\n          top: -50%;\r\n          left: 0;\r\n          width: 100%;\r\n          height: 200%;\r\n          display: block;\r\n          position: absolute;\r\n          clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);\r\n          z-index: -1;\r\n        }\r\n\r\n        &::before {\r\n          background: $hexagon-border-color;\r\n          transform: scale(1.055);\r\n        }\r\n\r\n        &::after {\r\n          background: $hexagon-image-color;\r\n          opacity: 0.4;\r\n          transition: opacity 350ms;\r\n        }\r\n\r\n        &:hover {\r\n          \r\n          .honeycomb-cell__title {\r\n            opacity: 0;\r\n          }\r\n          \r\n          &::before, &::after, .honeycomb-cell__image {\r\n            clip-path: unset!important;\r\n          }\r\n          \r\n          &::before {\r\n            background: $hexagon-border-color--hover;\r\n          }\r\n\r\n          &::after {\r\n            opacity: 0;\r\n          }\r\n        }\r\n      }\r\n\r\n      &__placeholder{\r\n        display:none;\r\n        opacity: 0;\r\n        width: $hexagon-width;\r\n        margin: 0 calc($hexagon-margin/2);\r\n      }\r\n    }\r\n\r\n    @media (max-width:#{2*$viewport-thereshold}){\r\n      .honeycomb-cell {\r\n        margin: calc(calc($hexagon-margin / 2) + calc($hexagon-height / 2)) $hexagon-margin;\r\n      }\r\n    }\r\n\r\n    @media (min-width: calc(2*$viewport-thereshold)) and (max-width:calc(3*$viewport-thereshold)){\r\n      .honeycomb-cell:nth-child(3n) {\r\n        margin-right: calc(50% - calc($hexagon-width/2));\r\n        margin-left: calc(50% - calc($hexagon-width/2));\r\n      }\r\n\r\n      .honeycomb__placeholder:nth-child(3n + 5) {\r\n        display:block;\r\n      }\r\n    }\r\n\r\n    @media (min-width: #{3*$viewport-thereshold}) and (max-width:#{4*$viewport-thereshold}) {\r\n      .honeycomb-cell:nth-child(5n + 4) {\r\n        margin-left: calc(50% - #{$hexagon-width + $hexagon-margin});\r\n      }\r\n\r\n      .honeycomb-cell:nth-child(5n + 5) {\r\n        margin-right: calc(50% - #{$hexagon-width + $hexagon-margin});\r\n      }\r\n\r\n      .honeycomb__placeholder:nth-child(5n), .honeycomb__placeholder:nth-child(5n + 3) {\r\n        display:block;\r\n      }\r\n    }\r\n\r\n    @media (min-width: #{4*$viewport-thereshold}) {\r\n      .honeycomb-cell:nth-child(7n + 5)  {\r\n        margin-left: calc(50% - #{$hexagon-width*1.5 + $hexagon-margin});\r\n      }\r\n\r\n      .honeycomb-cell:nth-child(7n + 7), .honeycomb-cell:nth-child(7n + 5):nth-last-child(2) {\r\n        margin-right: calc(50% - #{$hexagon-width*1.5 + $hexagon-margin});\r\n      }\r\n\r\n      .honeycomb__placeholder:nth-child(7n + 7), .honeycomb__placeholder:nth-child(7n + 9), .honeycomb__placeholder:nth-child(7n + 11){\r\n        display:block;\r\n      }\r\n    }\r\n  }\r\n\r\n  // mobile\r\n  @media only screen and (max-width: 767px) {\r\n    $hexagon-width: 100px;\r\n    $hexagon-height: $hexagon-width * 0.55;\r\n    $viewport-thereshold: $hexagon-width + $hexagon-margin;\r\n    $honeycomb-max-width: 767px;\r\n    @include honeycomb-styling($hexagon-width, $hexagon-height, $viewport-thereshold, $honeycomb-max-width);\r\n  }\r\n  \r\n  // Tablet devices\r\n  @media only screen and (min-width: 768px) and (max-width: 1023px) {\r\n    $hexagon-width: 200px;\r\n    $hexagon-height: $hexagon-width * 0.55;\r\n    $viewport-thereshold: $hexagon-width + $hexagon-margin;\r\n    $honeycomb-max-width: 1023px;\r\n    @include honeycomb-styling($hexagon-width, $hexagon-height, $viewport-thereshold, $honeycomb-max-width);\r\n  }\r\n  \r\n  // Desktop devices\r\n  @media only screen and (min-width: 1024px) {\r\n    $hexagon-width: 250px;\r\n    $hexagon-height: $hexagon-width * 0.55;\r\n    $viewport-thereshold: $hexagon-width + $hexagon-margin;\r\n    $honeycomb-max-width: 1200px;\r\n    @include honeycomb-styling($hexagon-width, $hexagon-height, $viewport-thereshold, $honeycomb-max-width);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
